(function() {
    let tlFreeGiftOfferClone;

    // Đánh chặn sự kiện click dành riêng cho nút Mua ngay (Permalink) trên Landing Page
    document.addEventListener("click", async function(e) {
        const anchor = e.target.closest("a");
        if (!anchor) return;

        const isTargetButton = anchor.classList.contains("hpl-button") || 
                               anchor.classList.contains("hpl-button-mobile") || 
                               anchor.closest(".hpl-buynow-mobile");
        if (!isTargetButton) return;
        
        let href = anchor.getAttribute("href");
        if (href && href.includes("/cart/") && href.includes("checkout")) {
            if (anchor.dataset.giftProcessed === "true") return;
            
            e.preventDefault();
            anchor.style.pointerEvents = "none"; // Khóa click đúp
            
            try {
                const urlObj = new URL(href, window.location.origin);
                const pathParts = urlObj.pathname.split("/cart/");
                if (pathParts.length > 1) {
                    const permalinkSegment = pathParts[1];
                    const items = permalinkSegment.split(",");
                    const firstItem = items[0].split(":");
                    const variantId = firstItem[0];
                    const quantity = parseInt(firstItem[1] || "1");

                    if (window.tlFreeGiftOffer && window.tlFreeGiftOffer.storefrontApi) {
                        const itemDataRes = await window.tlFreeGiftOffer.storefrontApi.getVariantData(variantId);
                        const itemData = itemDataRes?.node;

                        if (itemData) {
                            const itemPrice = parseFloat(itemData.price.amount) * window.tlFreeGiftOffer.currencyRate;
                            const itemInfo = {
                                id: variantId,
                                price: itemPrice,
                                discounted_price: itemPrice,
                                quantity: quantity,
                                productId: itemData.product.id.split("/").pop(),
                                selling_plan: false
                            };

                            // Sao lưu trạng thái thực tế của app
                            const currentItemsInCart = window.tlFreeGiftOffer.itemsInCart;
                            const currentRuleIdMapGifts = window.tlFreeGiftOffer.ruleIdMapGifts;
                            const currentRuleIdMapState = window.tlFreeGiftOffer.ruleIdMapState;
                            const currentCartHasChanged = window.tlFreeGiftOffer.cartHasChanged;

                            // Giả lập giỏ hàng phục vụ quét khuyến mãi
                            const itemsInOtherPayCart = new Map();
                            itemsInOtherPayCart.set(itemInfo.id, itemInfo);

                            window.tlFreeGiftOffer.itemsInCart = itemsInOtherPayCart;
                            window.tlFreeGiftOffer.ruleIdMapGifts = new Map();
                            window.tlFreeGiftOffer.ruleIdMapState = new Map();
                            window.tlFreeGiftOffer.cartHasChanged = true;

                            const discounts = [];
                            let giftsToAddResult = [];

                            for (const rule of window.tlFreeGiftOffer.rules) {
                                if (rule.auto_add_gift) {
                                    const { needToAdd, giftsToAdd } = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                                    if (needToAdd) {
                                        giftsToAddResult = giftsToAddResult.concat(giftsToAdd);
                                        discounts.push(rule.discount_code);
                                    }
                                }
                            }

                            // Khôi phục trạng thái gốc của app
                            window.tlFreeGiftOffer.itemsInCart = currentItemsInCart;
                            window.tlFreeGiftOffer.ruleIdMapGifts = currentRuleIdMapGifts;
                            window.tlFreeGiftOffer.ruleIdMapState = currentRuleIdMapState;
                            window.tlFreeGiftOffer.cartHasChanged = currentCartHasChanged;

                            const locationData = await window.tlFreeGiftOffer.getIpInfo();
                            const country = locationData?.country || "";
                            const region = locationData?.region || "";

                            // Đóng gói danh sách sản phẩm gửi API
                            const lines = [
                                {
                                    merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                                    quantity: quantity,
                                    attributes: []
                                }
                            ];
                            
                            // Gắn thuộc tính ẩn để Shopify Functions nhận diện quà tặng
                            for (const gift of giftsToAddResult) {
                                const attributes = [];
                                if (gift.properties) {
                                    for (const [key, value] of Object.entries(gift.properties)) {
                                        attributes.push({ key, value: String(value) });
                                    }
                                }
                                lines.push({
                                    merchandiseId: `gid://shopify/ProductVariant/${gift.id}`,
                                    quantity: gift.quantity,
                                    attributes: attributes
                                });
                            }

                            const countryCode = country ? country.toUpperCase() : "JP";
                            const languageCode = (Shopify?.locale || "ja").toUpperCase();

                            const variables = {
                                input: {
                                    lines: lines,
                                    attributes: [
                                        {
                                            key: window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE,
                                            value: `${country}-${region}`
                                        }
                                    ],
                                    discountCodes: discounts
                                },
                                country: countryCode,
                                language: languageCode
                            };

                            const query = `
                                mutation cartCreate($input: CartInput!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
                                    cartCreate(input: $input) {
                                        cart {
                                            checkoutUrl
                                        }
                                    }
                                }
                            `;

                            const shopifyShop = Shopify.shop;
                            const apiVersion = window.tlFreeGiftOffer.constants.API_VERSION || "2024-04";
                            const storefrontToken = window.tlFreeGiftOffer.storeAccessToken;

                            const response = await fetch(`https://${shopifyShop}/api/${apiVersion}/graphql.json`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Shopify-Storefront-Access-Token": storefrontToken
                                },
                                body: JSON.stringify({ query, variables })
                            });

                            const resData = await response.json();
                            const checkoutUrl = resData?.data?.cartCreate?.cart?.checkoutUrl;

                            if (checkoutUrl) {
                                href = checkoutUrl;
                            } else {
                                // Fallback sang Permalink dự phòng nếu Storefront API gặp lỗi
                                if (giftsToAddResult.length > 0) {
                                    let newPermalink = permalinkSegment;
                                    for (const gift of giftsToAddResult) {
                                        newPermalink += `,${gift.id}:${gift.quantity}`;
                                    }
                                    urlObj.pathname = pathParts[0] + "/cart/" + newPermalink;
                                    
                                    if (country) {
                                        urlObj.searchParams.set(`attributes[${window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE}]`, `${country}-${region}`);
                                    }
                                    
                                    if (urlObj.searchParams.has("checkout")) {
                                        urlObj.searchParams.delete("checkout");
                                        if (discounts.length > 0) {
                                            urlObj.searchParams.set("discount", discounts[0]);
                                        }
                                        href = urlObj.pathname + "?" + urlObj.searchParams.toString() + "&checkout";
                                    } else {
                                        if (discounts.length > 0) {
                                            urlObj.searchParams.set("discount", discounts[0]);
                                        }
                                        href = urlObj.pathname + urlObj.search;
                                    }
                                    href = href.replace(/%5B/g, "[").replace(/%5D/g, "]");
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                console.error("Error processing cart link override:", err);
            }
            
            anchor.dataset.giftProcessed = "true";
            window.location.href = href; 
        }
    }, true);

    // Cầu nối toàn cục lấy thông tin vị trí IP
    window.getIpInfo = async function() {
        if (tlFreeGiftOfferClone && typeof tlFreeGiftOfferClone.getIpInfo === 'function') {
            return await tlFreeGiftOfferClone.getIpInfo();
        }
        return { country: "", region: "" };
    };

    // Hàm áp dụng các ghi đè tùy biến lên window.tlFreeGiftOffer
    function applyOverrides(val) {
        if (!val || val.isCustomOverridden) return;
        val.isCustomOverridden = true;

        val.getIpInfo = async () => {
            try {
                if (!val.infoLocation) {
                    const ipInfoReq = await fetch('https://ipinfo.io/json');
                    const ipInfoRes = await ipInfoReq.json();
    
                    const country = ipInfoRes?.country || "";
                    const regionNorm = val.utils.normalizeProvinceName
                        ? val.utils.normalizeProvinceName(ipInfoRes?.region || "")
                        : (ipInfoRes?.region || "");
                    val.infoLocation = { country, region: regionNorm };
    
                    try {
                        await val.ajaxApi.cartUpdate({
                            attributes: {
                                [val.constants.LOCATION_CART_ATTRIBUTE]: `${country}-${regionNorm}`,
                            }
                        });
                    } catch (cartError) {
                        console.error("Error updating cart location attributes:", cartError);
                    }
                }
            } catch (error) {
                console.error("Error getting IP info:", error);
            }
            return val.infoLocation || { country: "", region: "" };
        };

        val.detectCartData = async () => {
            try {
                const cartData = await window.tlFreeGiftOffer.ajaxApi.cartGet();

                const itemsInCart = new Map();
                const ruleIdMapGifts = new Map();
                if(cartData.items.length){
                    const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                    const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                    for (let i = 0; i < cartData.items.length; i++) {
                        const item = cartData.items[i];
                        const itemKey = item.key;
                        const itemId = String(item.id);
                        const productId = String(item.product_id);
    
                        const appliedRuleId = window.tlFreeGiftOffer.checkLineItemIsGift(item);

                        if(appliedRuleId){
                            const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                            ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                id: itemId,
                                key: itemKey,
                                quantity: item.quantity,
                                price: item.price / ratio,
                                discounted_price: item.discounted_price / ratio
                            }])
                        } else if(!window.tlFreeGiftOffer.utils.isOtherModuleGift(item)) {
                            itemsInCart.set(itemKey, {
                                id: itemId,
                                price: item.price / ratio,
                                discounted_price: item.discounted_price / ratio,
                                quantity: item.quantity,
                                title: item.title,
                                image: item.image,
                                productId: productId,
                                selling_plan: !!item.selling_plan_allocation
                            })
                        }
                    }
                }

                window.tlFreeGiftOffer.itemsInCart = new Map(itemsInCart);
                window.tlFreeGiftOffer.ruleIdMapGifts = new Map(ruleIdMapGifts);
                window.tlFreeGiftOffer.itemsInTempCart.clear();
                window.tlFreeGiftOffer.ruleIdMapGiftsInTempCart.clear();
            } catch (error) {
                console.error("Error when detectCartData:", error);
            }
        };

        val.getCustomerBuy = async (rule) => {
            const checkApllyTo = window.tlFreeGiftOffer.makeApplyToChecker(rule);

            const parentInCart = [];
            let totalProductApplied = 0;
            let numberProductApplied = 0;

            const items = window.tlFreeGiftOffer.getItems(rule);
            for (let i = 0; i < items.length; i++) {
                const [key, itemData] = items[i];
                if(await checkApllyTo(itemData) && window.tlFreeGiftOffer.checkPurchaseType(itemData, rule.purchase_type)){
                    numberProductApplied += itemData.quantity;
                    totalProductApplied += itemData.discounted_price * itemData.quantity;

                    parentInCart.push({key, ...itemData})
                }
            }
            
            return {parentInCart, totalProductApplied, numberProductApplied}
        };
    }

    if (window.tlFreeGiftOffer) {
        tlFreeGiftOfferClone = window.tlFreeGiftOffer;
        applyOverrides(tlFreeGiftOfferClone);
    }

    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                applyOverrides(tlFreeGiftOfferClone);
            }
        },
        configurable: true
    });
})();
